import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  useTheme,
  Grid,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { tokens } from "../components/Theme";
import useMediaQuery from "@mui/material/useMediaQuery";
import RegisterHeader from "../components/RegisterHeader";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import thLocale from "date-fns/locale/th";
import CreateFarmer from "../api/farmer/CreateFarmer";
import GetFarmer from "../api/farmer/GetFarmer";
import { useNavigate } from "react-router-dom";
import UpdateFarmer from "../api/farmer/UpdateFarmer";
import { locations } from "../api/data/locationData";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function FarmerInfo() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const fileInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const userData = JSON.parse(localStorage.getItem("userdata"));
  const [imageExists, setImageExists] = useState(false);
  const [provinceList, setProvinceList] = useState(Object.keys(locations));
  const [amphurList, setAmphurList] = useState([]);
  const [tambonList, setTambonList] = useState([]);
  const [postCode, setPostCode] = useState("");
  const [formData, setFormData] = useState({
    appFarmerId: userData.appFarmerId,
    title: "",
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: null,
    idCard: userData.idCard,
    idCardExpiryDate: null,
    addr: "",
    province: "",
    amphur: "",
    tambon: "",
    postCode: "",
    email: "",
    mobileNo: userData.mobileNo,
    lineId: "",
    registrationNumber: "",
    registrationType: "",
  });

  const uploadImage = async () => {
    if (!fileInputRef.current.files[0]) return;

    const formDataImage = new FormData();
    formDataImage.append("file", fileInputRef.current.files[0]);
    formDataImage.append("appFarmerId", userData.appFarmerId);

    try {
      await fetch(`${process.env.REACT_APP_BACKEND_API}/api/farmer/img`, {
        method: "POST",
        body: formDataImage,
      });
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  useEffect(() => {
    const fetchFarmerData = async () => {
      if (userData.registor === 1) {
        try {
          const response = await GetFarmer({ appFarmerId: userData.appFarmerId });
          setFormData(response);
          setAmphurList(Object.keys(locations[response.province] || {}));
          setTambonList(Object.keys((locations[response.province] || {})[response.amphur] || {}));

          setFormData((prev) => ({
            ...prev,
            dateOfBirth: prev.dateOfBirth ? new Date(prev.dateOfBirth) : null,
            idCardExpiryDate: prev.idCardExpiryDate ? new Date(prev.idCardExpiryDate) : null,
          }));
        } catch (error) {
          console.error("Error fetching farmer data:", error);
        }
      }
    };

    fetchFarmerData();
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = "#EEE9E9";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);
  const handleProvinceChange = (e) => {
    const province = e.target.value;
    setFormData((prev) => ({
      ...prev,
      province,
      amphur: "",
      tambon: "",
      postCode: ""
    }));
    setAmphurList(Object.keys(locations[province]));
    setTambonList([]);
  };

  const handleAmphurChange = (e) => {
    const amphur = e.target.value;
    setFormData((prev) => ({
      ...prev,
      amphur,
      tambon: "",
      postCode: ""
    }));
    setTambonList(Object.keys(locations[formData.province][amphur]));
  };

  const handleTambonChange = (e) => {
    const tambon = e.target.value;
    const zip = locations[formData.province][formData.amphur][tambon];
    setFormData((prev) => ({
      ...prev,
      tambon,
      postCode: zip
    }));
  };

  useEffect(() => {
    const imageUrl = `${process.env.REACT_APP_STORAGE_URL}pea-daily/Farmer/${userData.appFarmerId}.png`;
    const img = new Image();

    img.onload = () => {
      setSelectedImage(imageUrl);
      setImageExists(true);
    };

    img.onerror = () => {
      setImageExists(false);
    };

    img.src = imageUrl;
  }, [userData.appFarmerId]);

  const toISOStringDate = (date) =>
    date ? date.toISOString().split("T")[0] : null;

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        dateOfBirth: toISOStringDate(formData.dateOfBirth),
        idCardExpiryDate: toISOStringDate(formData.idCardExpiryDate),
      };

      if (fileInputRef.current.files[0]) {
        await uploadImage();
      }

      if (userData.registor === 1) {
        await UpdateFarmer(payload);
        setSnackbarSeverity("success");
        setSnackbarMessage("แก้ไขข้อมูลสำเร็จ");
      } else {
        await CreateFarmer(payload);
        localStorage.setItem(
          "userdata",
          JSON.stringify({
            ...JSON.parse(localStorage.getItem("userdata")),
            registor: 1
          })
        );
        
        setSnackbarSeverity("success");
        setSnackbarMessage("ยืนยันข้อมูลสำเร็จ");
      }

      setOpenSnackbar(true);

      setTimeout(() => {
        navigate("/home");
      }, 1000);
    } catch (error) {
      console.error("Error submitting data:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      setOpenSnackbar(true);
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const RequiredLabel = ({ label }) => (
    <Typography>
      {label}{" "}
      <Box component="span" sx={{ color: "red" }}>
        *
      </Box>
    </Typography>
  );

  return (
    <Box sx={{ backgroundColor: "#EEE9E9" }}>
      <RegisterHeader />

      <Grid container spacing={2} ml="15px" mr="15px" mt="20px">
        <Grid item size={{ xs: 12, md: 12, lg: 12, xl: 12 }} textAlign="center">
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box flex={1} />
            <Box flex="auto" textAlign="center">
              <Typography variant={isMobile ? "h6" : "h5"}>
                ข้อมูลส่วนตัว
              </Typography>
            </Box>
            <Box flex={1} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                sx={{ bgcolor: colors.yellowAccent[500], borderRadius: "15px" ,color: "black",}}
                onClick={handleSubmit}
              >
                ข้าม
              </Button>
            </Box>
          </Box>

        </Grid>
        <Grid item size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
          <Box
            onClick={handleImageClick}
            sx={{
              width: isMobile ? "150px" : "300px",
              height: isMobile ? "150px" : "300px",
              border: "2px dashed gray",
              borderRadius: 2,
              cursor: "pointer",
              mx: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#fff",
              overflow: "hidden",
            }}
          >
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="uploaded"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Typography>อัปโหลดรูป</Typography>
            )}
          </Box>
        </Grid>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </Grid>


      <Grid container spacing={2} ml="15px" mr="15px" mt="30px">
        <Grid item size={{ xs: 3, md: 3, lg: 3, xl: 3 }}>
          <RequiredLabel label="คำนำหน้า" />
          <FormControl
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
          >
            <InputLabel id="title"></InputLabel>
            <Select
              name="title"
              labelId="title"
              id="title"
              value={formData.title}
              onChange={handleChange}
            >
              <MenuItem value="นาย">นาย</MenuItem>
              <MenuItem value="นางสาว">นางสาว</MenuItem>
              <MenuItem value="นาง">นาง</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item size={{ xs: 4.5, md: 4.5, lg: 4.5, xl: 4.5 }}>
          <RequiredLabel label="ชื่อจริง" />
          <TextField
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="firstName"
            InputLabelProps={{ shrink: false }}
            placeholder="ชื่อจริง"
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs: 4.5, md: 4.5, lg: 4.5, xl: 4.5 }}>
          <RequiredLabel label="นามสกุล" />
          <TextField
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            InputLabelProps={{ shrink: false }}
            fullWidth
            id="lastName"
            placeholder="นามสกุล"
            variant="outlined"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} ml="15px" mr="15px" mt="30px">
        <Grid item size={{ xs: 6, md: 6, lg: 3, xl: 3 }}>
          <RequiredLabel label="เพศ" />
          <FormControl
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
          >
            <InputLabel id="titles"></InputLabel>
            <Select
              name="gender"
              labelId="titles"
              id="titles"
              value={formData.gender}
              onChange={handleChange}
            >
              <MenuItem value="ชาย">ชาย</MenuItem>
              <MenuItem value="หญิง">หญิง</MenuItem>
              <MenuItem value="อื่นๆ">อื่นๆ</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item size={{ xs: 6, md: 6, lg: 2, xl: 2 }}>
          <RequiredLabel label="วัน/เดือน/ปี เกิด" />
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={thLocale}
          >
            <DatePicker
              name="dateOfBirth"
              value={formData.dateOfBirth}
              onChange={(newValue) => handleDateChange("dateOfBirth", newValue)}
              renderInput={(params) => (
                <TextField {...params} fullWidth placeholder="วว/ดด/ปปปป" />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item size={{ xs: 12, md: 4.5, lg: 4.5, xl: 4.5 }}>
          <RequiredLabel label="เลขบัตรประชาชน" />
          <TextField
            name="idCard"
            value={formData.idCard}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="Iden"
            InputLabelProps={{ shrink: false }}
            placeholder="เลขบัตรประชาชน"
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs: 6, md: 6, lg: 2, xl: 2 }}>
          <RequiredLabel label="วันหมดอายุบัตร" />
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={thLocale}
          >
            <DatePicker
              name="idCardExpiryDate"
              value={formData.idCardExpiryDate}
              onChange={(newValue) => handleDateChange("idCardExpiryDate", newValue)}
              renderInput={(params) => (
                <TextField {...params} fullWidth placeholder="วว/ดด/ปปปป" />
              )}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item size={{ xs: 12, md: 4.5, lg: 6, xl: 6 }}>
          <RequiredLabel label="ที่อยู่ตามบัตรประชาชน" />
          <TextField
            name="addr"
            value={formData.addr}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="addr"
            InputLabelProps={{ shrink: false }}
            placeholder=""
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs: 4, md: 4, lg: 3, xl: 3 }}>
          <RequiredLabel label="จังหวัด" />
          <FormControl fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "18px" } }}>
            <InputLabel id="province-label"></InputLabel>
            <Select
              labelId="province-label"
              name="province"
              value={formData.province}
              onChange={handleProvinceChange}
            >
              {provinceList.map((province) => (
                <MenuItem key={province} value={province}>
                  {province}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item size={{ xs: 4, md: 4, lg: 4, xl: 4 }}>
          <RequiredLabel label="อำเภอ" />
          <FormControl fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "18px" } }}>
            <InputLabel id="amphur-label"></InputLabel>
            <Select
              labelId="amphur-label"
              name="amphur"
              value={formData.amphur}
              onChange={handleAmphurChange}
              disabled={!formData.province}
            >
              {amphurList.map((amphur) => (
                <MenuItem key={amphur} value={amphur}>
                  {amphur}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item size={{ xs: 4, md: 4, lg: 4, xl: 4 }}>
          <RequiredLabel label="ตำบล" />
          <FormControl fullWidth sx={{ "& .MuiOutlinedInput-root": { borderRadius: "18px" } }}>
            <InputLabel id="tambon-label"></InputLabel>
            <Select
              labelId="tambon-label"
              name="tambon"
              value={formData.tambon}
              onChange={handleTambonChange}
              disabled={!formData.amphur}
            >
              {tambonList.map((tambon) => (
                <MenuItem key={tambon} value={tambon}>
                  {tambon}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item size={{ xs: 6, md: 6, lg: 4, xl: 4 }}>
          <RequiredLabel label="รหัสไปรษณีย์" />
          <TextField
            name="postCode"
            value={formData.postCode}
            onChange={handleChange}
            disabled
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "18px" } }}
            fullWidth
            id="postCode"
            InputLabelProps={{ shrink: false }}
            placeholder=""
            variant="outlined"
          />
        </Grid>



        <Grid item size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
          <RequiredLabel label="อีเมลล์ติดต่อ" />
          <TextField
            name="email"
            value={formData.email}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="email"
            InputLabelProps={{ shrink: false }}
            placeholder=""
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
          <RequiredLabel label="เลขทะเบียนเกษตรกร" />
          <TextField
            name="registrationNumber"
            value={formData.registrationNumber}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="registrationNumber"
            InputLabelProps={{ shrink: false }}
            placeholder=""
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
          <RequiredLabel label="ประเภทสมาชิก" />
          <TextField
            name="registrationType"
            value={formData.registrationType}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="registrationType"
            InputLabelProps={{ shrink: false }}
            placeholder=""
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
          <RequiredLabel label="ไอดีไลน์" />
          <TextField
            name="lineId"
            value={formData.lineId}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="lineId"
            InputLabelProps={{ shrink: false }}
            placeholder=""
            variant="outlined"
          />
        </Grid>
        <Grid item size={{ xs: 6, md: 6, lg: 6, xl: 6 }}>
          <RequiredLabel label="เบอร์ไทรศัพท์" />
          <TextField
            name="mobileNo"
            value={formData.mobileNo}
            onChange={handleChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "18px",
              },
            }}
            fullWidth
            id="mobileNo"
            InputLabelProps={{ shrink: false }}
            placeholder=""
            variant="outlined"
          />
        </Grid>
      </Grid>
      <Box p="20px" display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          sx={{ bgcolor: colors.greenAccent[400], borderRadius: "15px" }}
          onClick={handleSubmit}
        >
          {userData.registor === 1 ? "อัพเดทข้อมูล" : "ยืนยันข้อมูล"}
        </Button>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default FarmerInfo;


